import { notEmpty, type Optional } from '@festina-life/core'
import { withSuspense } from '@festina-life/ui/libs'
import { useDataContext } from '@festina-life/ui/theme'

import { useHook } from '../../../lenteHooks'
import { BankAccountDetails } from './BankAccountDetails'
import { PaymentChannelCriteria } from './PaymentChannelCriteria'

type Props = { channelId: Optional<string> }

const PaymentChannelOptionInternal = ({ channelId }: Props) => {
  const { previousEventId } = useDataContext()
  const { tenantId, legalEntityId } = useHook(
    'routing.general.useLegalEntityParams',
  )()

  const { data: paymentReceiverVersionLatest } = useHook(
    'fetchers.moneyOut.useFetchPaymentReceiverVersionLatest',
  )({
    tenantId,
    receiverId: legalEntityId,
  })

  //Fetching the version with previousEventId to be able to render the metadata of a payment channel after its deletion.
  const { data: paymentReceiverVersionByEventId } = useHook(
    'fetchers.moneyOut.useFetchPaymentReceiverVersionByEventId',
  )(
    previousEventId
      ? {
          tenantId,
          receiverId: legalEntityId,
          eventId: previousEventId,
        }
      : null,
    { enabled: !!previousEventId },
  )
  const paymentReceiverVersion =
    paymentReceiverVersionByEventId ?? paymentReceiverVersionLatest
  const paymentChannel = [
    ...(paymentReceiverVersion?.additionalPaymentChannels ?? []),
    paymentReceiverVersion?.defaultPaymentChannel,
  ]
    ?.filter(notEmpty)
    .find(({ _id }) => _id === channelId)

  return (
    <>
      {paymentChannel ? (
        <>
          <BankAccountDetails
            paymentChannel={paymentChannel}
            showBankAccountType
          />{' '}
          <PaymentChannelCriteria
            paymentChannelCriteria={paymentChannel?.paymentChannelCriteria}
          />
        </>
      ) : undefined}
    </>
  )
}

export const PaymentChannelOption = withSuspense(PaymentChannelOptionInternal)
